<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Value card') }}<span class="text-danger" v-if="!parseInt(valuecard.status)"> ({{ _('Inactive') }})</span></h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="name">{{ _('Name') }}</label>
            <input class="form-control" type="text" id="name" :value="valuecard.name" />
          </div>
          <div class="form-group">
            <input class="form-control" type="text" id="code" :value="valuecardCode" />
          </div>
          <div class="form-group">
            <input class="form-control" type="text" id="email" v-model="valuecardEmail" :placeholder="_('Email')" />
          </div>
        </div>
      </div>
      <div class="row" v-if="parseInt(valuecard.status)">
        <div class="col-md-12">
          <img :src="qrCodeUrl" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="sendEmail" v-if="parseInt(valuecard.status)" :disabled="!valuecardEmail"><i :class="'fa fa-' + sendIcon + ' fa-fw'"></i> {{ _('Send email') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'
import axios from 'axios'

export default {
  mixins: [errors],
  props: ['valuecard', 'order', 'baseDomain', 'shopId', 'apiKey', 'locale', 'settings'],
  data () {
    return {
      email: null,
      sendingEmail: false
    }
  },
  computed: {
    sendIcon () {
      return this.sendingEmail ? 'refresh fa-spin' : 'send'
    },
    valuecardEmail: {
      get () {
        if (this.email) {
          return this.email
        }
        return this.order.email
      },
      set (newValue) {
        this.email = newValue
      }
    },
    valuecardCode () {
      if (!this.valuecard || !this.valuecard.code || !this.valuecard.code.match) {
        return ''
      }
      return this.valuecard.code.match(/.{1,4}/g).join('-')
    },
    qrCodeUrl() {
      return 'https://qrcode.johku.com/?code=' + this.baseDomain + this.shopId + '/qr/V' + this.valuecard.code + '&size=5&margin=1'
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    async sendEmail() {
      let response
      this.sendingEmail = true
      this.showNotification(this._('Processing, please wait...'))
      try {
        const data = {
          id: this.order.id
        }
        response = await axios.put(this.baseDomain + this.shopId + '/orders/' + this.order.id + '.json?valuecard=' + this.valuecard.id + '&email=' + this.email + '&apikey=' + this.apiKey, data)
        this.showNotification(this._('Message sent!'))
      } catch(e) {
        this.showError(e)
      }
      this.sendingEmail = false
    },
  }
}
</script>